"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAddPolicyPath = exports.getInfoText = exports.isResourceProfilePolicyAddOrEditPath = exports.isResourceProfileAdvancedSettingsPath = exports.isApplicationProfilePolicyAddOrEditPath = exports.isApplicationProfileAdvancedSettingsPath = exports.isApplicationAdvancedSettingsPath = exports.isValidRegex = exports.isPolicyPath = exports.isProfilePath = exports.validateRegex = void 0;

var validateRegex = function validateRegex(regexInput, stringInput) {
  // If regexInput is empty, consider it valid
  if (!regexInput) return true; // If stringInput is empty, check if regexInput is valid

  if (!stringInput) return isValidRegex(regexInput);

  try {
    var regex = new RegExp(regexInput);
    var isMatch = regex.test(stringInput);
    return isMatch; // Return true if regex matches, otherwise false
  } catch (error) {
    return false; // Return false if the regex is invalid
  }
};

exports.validateRegex = validateRegex;

var isProfilePath = function isProfilePath() {
  // Check if the pathname contains the desired segment
  return location.pathname.includes('/details/advanced-settings');
};

exports.isProfilePath = isProfilePath;

var isPolicyPath = function isPolicyPath() {
  // Check if the pathname contains the desired segment
  return location.pathname.includes('/policies/manage');
};

exports.isPolicyPath = isPolicyPath;

var isValidRegex = function isValidRegex(input) {
  try {
    new RegExp(input); // Attempt to create a RegExp with the input

    return true; // If no error, the input is a valid regex
  } catch (e) {
    return false; // If an error occurs, the input is not a valid regex
  }
};

exports.isValidRegex = isValidRegex;

var isApplicationAdvancedSettingsPath = function isApplicationAdvancedSettingsPath() {
  var regex = /^\/admin\/applications\/[^/]+\/advanced-settings$/;
  return regex.test(location.pathname);
};

exports.isApplicationAdvancedSettingsPath = isApplicationAdvancedSettingsPath;

var isApplicationProfileAdvancedSettingsPath = function isApplicationProfileAdvancedSettingsPath() {
  var regex = /^\/admin\/applications\/[^/]+\/profiles\/[^/]+\/details\/advanced-settings$/;
  return regex.test(location.pathname);
};

exports.isApplicationProfileAdvancedSettingsPath = isApplicationProfileAdvancedSettingsPath;

var isApplicationProfilePolicyAddOrEditPath = function isApplicationProfilePolicyAddOrEditPath() {
  var regex = /^\/admin\/applications\/[^/]+\/profiles\/[^/]+\/details\/policies\/manage\/(add|edit\/[^/]+)$/;
  return regex.test(location.pathname);
};

exports.isApplicationProfilePolicyAddOrEditPath = isApplicationProfilePolicyAddOrEditPath;

var isResourceProfileAdvancedSettingsPath = function isResourceProfileAdvancedSettingsPath() {
  var regex = /^\/admin\/resources-manager\/profile-management\/manage\/[^/]+\/advanced-settings(?:\/)?$/;
  return regex.test(location.pathname);
};

exports.isResourceProfileAdvancedSettingsPath = isResourceProfileAdvancedSettingsPath;

var isResourceProfilePolicyAddOrEditPath = function isResourceProfilePolicyAddOrEditPath() {
  var regex = /^\/admin\/resources-manager\/profile-management\/manage\/[^/]+\/policies\/manage\/(add|edit\/[^/]+)$/;
  return regex.test(location.pathname);
};

exports.isResourceProfilePolicyAddOrEditPath = isResourceProfilePolicyAddOrEditPath;
var Application = 'Advanced Settings will be applied to all Profiles and Policies within this application, unless specific settings are configured for individual Profiles or Policies.';
var ApplicationAndResourceProfile = 'Advanced Settings will be applied to all Policies within this profile, unless specific settings are configured for individual Policies.';
var ApplicationProfilePolicy = 'Advanced Settings will be inherited from the Profile or Application, following this hierarchy, unless specific settings are configured here.';
var ResourceProfilePolicy = 'Advanced Settings will be inherited from the higher-level Profile, unless specific settings are configured here.';

var getInfoText = function getInfoText() {
  if (isApplicationAdvancedSettingsPath()) {
    return Application;
  }

  if (isApplicationProfileAdvancedSettingsPath() || isResourceProfileAdvancedSettingsPath()) {
    return ApplicationAndResourceProfile;
  }

  if (isApplicationProfilePolicyAddOrEditPath()) {
    return ApplicationProfilePolicy;
  }

  if (isResourceProfilePolicyAddOrEditPath()) {
    return ResourceProfilePolicy;
  }

  return '';
};

exports.getInfoText = getInfoText;

var isAddPolicyPath = function isAddPolicyPath() {
  var _location;

  var path = (_location = location) === null || _location === void 0 ? void 0 : _location.pathname; // Check if the path ends with /policies/manage/add

  if (!path.endsWith('/policies/manage/add')) {
    return false;
  } // Split the path and check for the required patterns


  var pathParts = path.split('/');
  var matchesFirstPattern = pathParts.includes('applications') && pathParts.includes('profiles');
  var matchesSecondPattern = pathParts.includes('resources-manager') && pathParts.includes('profile-management'); // Return true if either pattern matches

  return matchesFirstPattern || matchesSecondPattern;
};

exports.isAddPolicyPath = isAddPolicyPath;